import { render } from "./form.vue?vue&type=template&id=f75be40a&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=f75be40a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ssp-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f75be40a"]])

export default __exports__